application.register("comp_visual", class extends Stimulus.Controller {
    connect() {
        if(this.element.querySelector(`[data-click="scrollNext"]`)) {
            this.element.querySelector(`[data-click="scrollNext"]`).addEventListener("click", () => {
                LibLenis.scrollTo(this.element.nextElementSibling);
            });
        }
    }
});
